import * as React from 'react';

import Input from './Input';
import { IInputProps } from './InputCommon';
export { IInputProps as IDateInputProps };

export default React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement> & IInputProps>((
  props, ref
) => <Input {...props} ref={ref} type='date' />);
